import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7.625 4.5C7.625 4.15482 7.34518 3.875 7 3.875C6.65482 3.875 6.375 4.15482 6.375 4.5V7C6.375 7.14621 6.42626 7.28779 6.51986 7.40012L9.01986 10.4001C9.24084 10.6653 9.63494 10.7011 9.90012 10.4801C10.1653 10.2592 10.2011 9.86506 9.98014 9.59988L7.625 6.77372V4.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }